// filepath: src/firebase/firestore/useIcrDocumentSubscription.js
import {useEffect, useState} from 'react';

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token ? {'Authorization': `Bearer ${token}`} : {};
}

async function fetchJson(path) {
    const r = await fetch(`${BASE}${path}`, {headers: authHeaders()});
    if (r.status === 404) return null;
    if (!r.ok) throw new Error(`${r.status}`);
    return r.json();
}

/**
 * Fetch a single ICR document by icrNumber (or legacy icrNumber), falling back to document id.
 * Pending proposals have no number until approved — route keys use id in that case.
 * Returns: { data, loading, error }
 */
export function useIcrDocumentSubscription(icrNumber) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!icrNumber) {
            setData(null);
            setLoading(false);
            setError(null);
            return;
        }

        let cancelled = false;
        setLoading(true);
        setError(null);

        (async () => {
            try {
                let doc = await fetchJson(
                    `/api/intelligence-requests/by-icr-number/${encodeURIComponent(icrNumber)}`,
                );
                if (!doc) {
                    doc = await fetchJson(
                        `/api/intelligence-requests/${encodeURIComponent(icrNumber)}`,
                    );
                }
                if (!cancelled) {
                    setData(doc);
                    setLoading(false);
                }
            } catch (err) {
                if (!cancelled) {
                    setError(err);
                    setLoading(false);
                }
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [icrNumber]);

    return {data, loading, error};
}
